// extracted by mini-css-extract-plugin
export default {"stripe":"mgDIoM7vJNA3NO4PRzgB","expanded":"_xm4WqIhxwnq6N2eH4Om"};